import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { expenseReportQueryConfig } from '@webapp/modules/expense/query-configs/expenseReport'

interface ReviseExpenseReportMutationParams {
  expenseId: number
  uuid: string
  payload: {
    title: string
    department: number
    travel: Nullable<number>
    notes: string
    next_approver: number
  }
}

export const useMutateReviseExpenseReport = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    void,
    RepoError,
    ReviseExpenseReportMutationParams
  >({
    mutationFn: ({ expenseId, payload }) =>
      expenseRepository.resubmit(expenseId, payload),

    onSuccess: (_data, { uuid }) => {
      queryClient.invalidateQueries({
        queryKey: expenseReportQueryConfig.detail(uuid).queryKey,
      })
    },
  })

  return {
    mutate: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
